import { Dictionary } from '@/dictionary/Dictionary'
import i18n from '@/i18n'

const paymentSumDistributionDict: Array<Dictionary> = []

for (const code of ['delivery', 'order_products']) {
    paymentSumDistributionDict.push({
        code: code,
        name: i18n.t(`dictionary.paymentSumDistribution.${code}`).toString()
    })
}

export { paymentSumDistributionDict }
